import React, { Component } from 'react';
import mixpanel from "mixpanel-browser";
import ContactModal from './ContactModal';

import './content/content.css';

class ContactModalContainer extends Component {

	constructor(props) {
		super(props);
		this.mixpanel = mixpanel;

		let fa = this.props.fa ? this.props.fa : "fa-envelope-open-o";
		let messageInputCollapsed = (typeof this.props.messageInputCollapsed !== "undefined") ? this.props.messageInputCollapsed : false;

		this.state = { toggle: this.props.toggle, fa: fa, contactModalVisible: false, contactModalTopic: this.props.topic, 
			contactModalMessage: this.props.message, contactModalCue: this.props.cue, contactModalPush: this.props.push, 
			messageInputCollapsed: messageInputCollapsed };

		this.handleShowContactUs = this.handleShowContactUs.bind(this);
		this.handleHideContactUs = this.handleHideContactUs.bind(this);
	}

	componentWillReceiveProps(props) {
		if (this.props.toggle !== props.toggle) {
			this.setState({contactModalVisible: !this.state.contactModalVisible});
		}
	}

	handleShowContactUs() {
		this.setState({contactModalVisible: true, fa: "fa-envelope-open-o", contactModalTopic: "Webfinery", 
			contactModalCue: "Contact Us",
			contactModalPush: "",
			messageInputCollapsed: false
		});
	}

	handleHideContactUs() {
		this.setState({contactModalVisible: false});	
	}

	render() { 
		return (
			<div>
				<ContactModal fa={this.state.fa} topic={this.state.contactModalTopic} message={this.state.contactModalMessage} 
					contactModalCue={this.state.contactModalCue} contactModalPush={this.state.contactModalPush} 
					visible={this.state.contactModalVisible} handleHide={this.handleHideContactUs} 
					submittedLabel={this.state.contactModalSubmittedLabel} 
					messageInputCollapsed={this.state.messageInputCollapsed} />
			</div>
		);
	}

}

export default ContactModalContainer;


// WEBPACK FOOTER //
// ./src/ContactModalContainer.js